import { createSelector } from '@reduxjs/toolkit';

import type { ProcessFlowData } from './_selector.type';
import type { ProcessFlowState } from './_state.type';

/** ProcessFlow Selector. */
export const processFlowSelector = {
  processFlow_getProcessFlow: createSelector(
    (state: ProcessFlowState) => state.processFlow.dataJSON,
    (state: ProcessFlowState) => state.processFlow.rawInitialStepsJSON,

    (dataJSON, rawInitialStepsJSON): ProcessFlowData => ({
      data: dataJSON ? JSON.parse(dataJSON) : undefined,
      rawInitialSteps: rawInitialStepsJSON ? JSON.parse(rawInitialStepsJSON) : undefined,
    }),
  ),
};
